import React from "react"
import { Box, Typography } from "@mui/material"

export default function singleColumn({ label, value }) {
	return {
		name: value,
		label: label,
		options: {
			customBodyRowRenderLite: (cellValue) => (
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<Typography>{cellValue}</Typography>
				</Box>
			),
		},
	}
}
